import { FETCH_QUALIFICATION_FAILURE, FETCH_QUALIFICATION_REQUEST, FETCH_QUALIFICATION_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posQualificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_QUALIFICATION_REQUEST:
            return {
                ...state,
            }
        case FETCH_QUALIFICATION_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_QUALIFICATION_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}